export const PermissionSetRoleNames: readonly string[] = ["extended_access"]

export enum ExtendedAccessStatus {
	Available = "available",
	/** @lintignore */
	Active = "active",
	/** @lintignore */
	Expired = "expired",
}

export enum UsageFeature {
	ParcelReport = "parcel_report",
}

export type ExtendedAccess = {
	status: ExtendedAccessStatus
	endsAt: string | null
	usageQuotas: UsageQuota[]
}

export type UsageQuota = {
	feature: UsageFeature
	remaining: number
}
